import './components/share'

import './scss/st4/styles.scss'
